export const section = {
  name: { key: "name" },
  zoneId: { key: "zoneId" },
  locationName: { key: "locationName" },
  isActive: { key: "isActive" },
  resources: { key: "resources" },
};

export const sectionListResponse = {
  zoneId: { key: "zoneId" },
  name: { key: "name" },
  locationName: { key: "locationName" },
  isActive: { key: "isActive" },
  resources: { key: "resources" },
};

export const sectionDetailResponse = {
  zoneId: { key: "zoneId" },
  name: { key: "name" },
  locationName: { key: "locationName" },
  isActive: { key: "isActive" },
  resources: { key: "resources" },
};

export const sectionListFilterRequest = {
  venueId: { key: "venueId" },
  locationId: { key: "locationId" },
  page: { key: "page" },
  pageSize: { key: "pageSize" },
  searchKey: { key: "searchKey" },
};

export const sectionRequest = {
  name: { key: "name" },
  venueId: { key: "venueId" },
  sectionId: { key: "id" },
  isActive: { key: "isActive" },
  locationId: { key: "locationId" },
};